import { Box } from '@hover/blueprint';
import React from 'react';

import { Designer } from 'src/shared/constants/FeatureFlag';
import { useTreatment } from 'src/shared/hooks';
import { isEnabled } from 'src/shared/telemetry/featureFlag';

import type { AiOrSampleGeneratedImage } from '../../types';

import { LensButton } from './LensButton';

interface ImageActionsProps {
  image: AiOrSampleGeneratedImage;
}

export const ImageActions = ({ image }: ImageActionsProps) => {
  const isLensEnabled = isEnabled(useTreatment(Designer.GOOGLE_LENS));

  return isLensEnabled ? (
    <Box
      bottom={0}
      justifyContent="flex-end"
      left={0}
      padding={500}
      position="absolute"
      right={0}
    >
      <LensButton image={image} />
    </Box>
  ) : null;
};
